import script from "./WaxWeight.vue?vue&type=script&setup=true&lang=js"
export * from "./WaxWeight.vue?vue&type=script&setup=true&lang=js"

import "./WaxWeight.vue?vue&type=style&index=0&id=28041e63&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28041e63"]])

export default __exports__